import {
  MAIN_SIDE_NAV_OVERLAY_TRAY_LIST_ITEM_ESTIMATED_HEIGHT,
  MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_GAP,
  MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_HEADER_ESTIMATED_HEIGHT,
} from '~/components/v2/components/workspace/main-side-nav/mainSideNavOverlayTrayVirtualRowSize';

export type WorkspaceUploadsVirtualRow =
  | {
      type: 'inProgress';
      uploadId: string;
    }
  | {
      count: number;
      type: 'failedHeader';
      withSectionGap: boolean;
    }
  | {
      type: 'failed';
      uploadId: string;
    }
  | {
      count: number;
      type: 'completedHeader';
      withSectionGap: boolean;
    }
  | {
      type: 'completed';
      uploadId: string;
    };

export type BuildWorkspaceUploadsVirtualRowsParams = {
  completedIds: string[];
  failedIds: string[];
  inProgressIds: string[];
};

export const buildWorkspaceUploadsVirtualRows = ({
  completedIds,
  failedIds,
  inProgressIds,
}: BuildWorkspaceUploadsVirtualRowsParams): WorkspaceUploadsVirtualRow[] => {
  const rows: WorkspaceUploadsVirtualRow[] = [];

  inProgressIds.forEach((uploadId) => {
    rows.push({
      type: 'inProgress',
      uploadId,
    });
  });

  if (failedIds.length > 0) {
    rows.push({
      count: failedIds.length,
      type: 'failedHeader',
      withSectionGap: rows.length > 0,
    });

    failedIds.forEach((uploadId) => {
      rows.push({ type: 'failed', uploadId });
    });
  }

  if (completedIds.length > 0) {
    rows.push({
      count: completedIds.length,
      type: 'completedHeader',
      withSectionGap: rows.length > 0,
    });

    completedIds.forEach((uploadId) => {
      rows.push({ type: 'completed', uploadId });
    });
  }

  return rows;
};

export const getWorkspaceUploadsVirtualRowKey = (row: WorkspaceUploadsVirtualRow) => {
  switch (row.type) {
    case 'inProgress':
      return `in-progress-${row.uploadId}`;
    case 'failedHeader':
      return 'failed-header';
    case 'failed':
      return `failed-${row.uploadId}`;
    case 'completedHeader':
      return 'completed-header';
    case 'completed':
      return `completed-${row.uploadId}`;
  }
};

export const estimateWorkspaceUploadsVirtualRowSize = (row: WorkspaceUploadsVirtualRow) => {
  switch (row.type) {
    case 'failedHeader':
    case 'completedHeader':
      return row.withSectionGap
        ? MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_HEADER_ESTIMATED_HEIGHT + MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_GAP
        : MAIN_SIDE_NAV_OVERLAY_TRAY_SECTION_HEADER_ESTIMATED_HEIGHT;
    default:
      return MAIN_SIDE_NAV_OVERLAY_TRAY_LIST_ITEM_ESTIMATED_HEIGHT;
  }
};
